import {Injectable} from '@angular/core';
import {Action, createSelector, State, StateContext} from '@ngxs/store';
import {UmpireOttStream} from '@tisa-group/models';
import {LoadStream} from './stream.actions';
import {patch} from '@ngxs/store/operators';
import {OttStreamService} from '@tisa-group/core/api/umpire';
import {Observable, tap} from 'rxjs';
import {JsonApiResponse} from '@tisa-group/cdk';

export type StreamStateModel = Record<string, JsonApiResponse<UmpireOttStream>>;

@State<StreamStateModel>({
  name: 'Stream',
  defaults: {},
})
@Injectable()
export class StreamState {
  @Action(LoadStream)
  loadStream(
    ctx: StateContext<StreamStateModel>,
    action: LoadStream,
  ): Observable<JsonApiResponse<UmpireOttStream>> | JsonApiResponse<UmpireOttStream> {
    const stateStream = ctx.getState()[action.eventSlug];

    if (stateStream && stateStream.data?.manifests?.hls) {
      return stateStream;
    }

    return this.streamService
      .fetch(action.eventSlug, {
        include: ['marker'].join(','),
      })
      .pipe(
        tap(res =>
          ctx.setState(
            patch({
              [action.eventSlug]: res,
            }),
          ),
        ),
      );
  }

  static getStreamByEventSlug(
    slug: string,
  ): (state: StreamStateModel) => JsonApiResponse<UmpireOttStream> {
    return createSelector<(state: StreamStateModel) => JsonApiResponse<UmpireOttStream>>(
      [StreamState],
      state => {
        return state[slug];
      },
    );
  }

  constructor(readonly streamService: OttStreamService) {}
}
